
import {defineComponent} from "vue";

export default defineComponent({
  name: "heading-with-filter",
  props: {
    title: {type: String, required: true},
    sortType: {type: String, required: true},
    search: {type: String, required: true}
  },
  methods: {
    changeSort: function (value: string) {
      this.$emit("update:sortType", value)
    },
    changeSearch: function (value: string) {
      this.$emit("update:search", value)
    }
  },
  setup(){
    const items = [
      {
        title: "Title",
        value: "title",
      },
      {
        title: "High price",
        value: "high_price",
      },
      {
        title: "Low price",
        value: "low_price",
      }
    ];
    return {items}
    }
})
